export default __webpack_public_path__ + "static/media/fbc.908f2ee3.png";